import React from 'react';

import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

export interface NavigationBarProps {
  id?: string;
  title?: string;
  titleClassName?: string;
  subtitle?: string;
  rightComponent?: React.ReactNode;
  subtitleClassName?: string;
  leftComponent?: React.ReactNode;
}

const getNavigationBarTitleId = (props: Pick<NavigationBarProps, 'id'>) => {
  return `${props.id || 'navigation-bar'}-title`;
};

export const NavigationBar: React.FC<NavigationBarProps> = ({
  id,
  title,
  titleClassName,
  subtitle,
  rightComponent,
  subtitleClassName,
  leftComponent,
}) => {
  const hasTitle = !!title;
  return (
    <Row
      id={id}
      className="z-[2000] shrink basis-auto flex-1 items-center justify-start bg-od-bg-primary py-3.5 pl-6 pr-5 md:pl-8 lg:pl-10"
    >
      {leftComponent && (
        <Row
          className={cn(
            'shrink-[2] items-center justify-start',
            hasTitle ? 'basis-1/2' : 'basis-auto',
          )}
        >
          {leftComponent}
        </Row>
      )}
      {title && (
        <Col className="shrink basis-full">
          <Text
            as="h1"
            id={getNavigationBarTitleId({ id })}
            className={cn('truncate text-label-md', titleClassName)}
          >
            {title}
          </Text>
          {subtitle && (
            <Text as="h2" className={cn('truncate text-body-lg', subtitleClassName)}>
              {subtitle}
            </Text>
          )}
        </Col>
      )}

      <Row
        className={cn('shrink-[2] items-center justify-end', hasTitle ? 'basis-1/2' : 'basis-auto')}
      >
        {rightComponent}
      </Row>
    </Row>
  );
};
